import { 
    CLEAR_GET_PENDING_VEHICLE_INSPECTION_STATE,
    DELETE_CHECKLIST_COMPONENT_FAIL,
    DELETE_CHECKLIST_COMPONENT_LOADING,
    DELETE_CHECKLIST_COMPONENT_SUCCESS,
    EDIT_CHECKLIST_COMPONENT_FAIL,
    EDIT_CHECKLIST_COMPONENT_LOADING,
    EDIT_CHECKLIST_COMPONENT_SUCCESS,
    GET_INSPECTION_CHECKLIST_FAIL, 
    GET_INSPECTION_CHECKLIST_LOADING, 
    GET_INSPECTION_CHECKLIST_SUCCESS, 
    GET_LICENSE_STATUS_FAIL, 
    GET_LICENSE_STATUS_LOADING, 
    GET_LICENSE_STATUS_SUCCESS, 
    GET_PENDING_VEHICLE_INSPECTION_FAIL, 
    GET_PENDING_VEHICLE_INSPECTION_LOADING, 
    GET_PENDING_VEHICLE_INSPECTION_SUCCESS, 
    GET_VEHICLE_ROUTE_INSPECTION_FAIL, 
    GET_VEHICLE_ROUTE_INSPECTION_LOADING, 
    GET_VEHICLE_ROUTE_INSPECTION_SUCCESS, 
    GET_VEHICLE_ROUTES_FAIL, 
    GET_VEHICLE_ROUTES_LOADING, 
    GET_VEHICLE_ROUTES_SUCCESS, 
    GET_VEHICLE_STATUS_FAIL, 
    GET_VEHICLE_STATUS_LOADING, 
    GET_VEHICLE_STATUS_SUCCESS, 
    POST_INSPECTION_CHECKLIST_FAIL, 
    POST_INSPECTION_CHECKLIST_LOADING,
    POST_INSPECTION_CHECKLIST_SUCCESS,
    POST_VEHICLE_INSPECTION_FAIL,
    POST_VEHICLE_INSPECTION_LOADING,
    POST_VEHICLE_INSPECTION_SUCCESS} from "../Components/Constants/ActionTypes";
import AxiosHelper from "../Helpers/AxiosHelper";

export const getInspectionChecklists = (params)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:GET_INSPECTION_CHECKLIST_LOADING
        });
    
        AxiosHelper.get(`/inspections/checklist/`,{
            params:params
        }).then(
            (res)=>{
                dispatch({
                    type:GET_INSPECTION_CHECKLIST_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:GET_INSPECTION_CHECKLIST_FAIL,
                    payload:err.response.data.message,
                })
                reject(err)
            }
        )
    })
}

export const postInspections = (payload)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:POST_INSPECTION_CHECKLIST_LOADING
        });
    
        AxiosHelper.post('/inspections/checkpoint/',{payload}).then(
            (res)=>{
                dispatch({
                    type:POST_INSPECTION_CHECKLIST_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:POST_INSPECTION_CHECKLIST_FAIL,
                    payload:err?.response?.data?.message,
                })
                reject(err)
            }
        )
    })
}

export const fetchVehicleStatus = (params)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:GET_VEHICLE_STATUS_LOADING
        });
    
        AxiosHelper.get(`/inspections/vehicle-status/`,{
            params:params
        }).then(
            (res)=>{
                dispatch({
                    type:GET_VEHICLE_STATUS_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:GET_VEHICLE_STATUS_FAIL,
                    payload:err.response.data.message,
                })
                reject(err)
            }
        )
    })
}

export const fetchLicenseStatus = (params)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:GET_LICENSE_STATUS_LOADING
        });
    
        AxiosHelper.get(`/inspections/license-status/`,{
            params:params
        }).then(
            (res)=>{
                dispatch({
                    type:GET_LICENSE_STATUS_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:GET_LICENSE_STATUS_FAIL,
                    payload:err.response.data.message,
                })
                reject(err)
            }
        )
    })
}

export const getPendingVehicleInspection = (params)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:GET_PENDING_VEHICLE_INSPECTION_LOADING
        });
    
        AxiosHelper.get(`/inspections/session-status/`,{
            params:params
        }).then(
            (res)=>{
                dispatch({
                    type:GET_PENDING_VEHICLE_INSPECTION_SUCCESS,
                    payload:res.data
                })
                resolve(res.data);
            }
        ).catch(
            (err)=>{
                dispatch({
                    type:GET_PENDING_VEHICLE_INSPECTION_FAIL,
                    payload:err.response.data.message,
                })
                reject(err)
            }
        )
    })
}

export const clearVehicleInspection = (dispatch)=>{
    dispatch({
        type:CLEAR_GET_PENDING_VEHICLE_INSPECTION_STATE
    })
}

export const createInspectionTransaction = (payload)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:POST_VEHICLE_INSPECTION_LOADING
        });
    
        AxiosHelper.post('/inspections/transaction/',{payload}).then(
            (res)=>{
                dispatch({
                    type:POST_VEHICLE_INSPECTION_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:POST_VEHICLE_INSPECTION_FAIL,
                    payload:err?.response?.data?.message,
                })
                reject(err)
            }
        )
    })
}


export const deleteChecklistItem = (payload)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:DELETE_CHECKLIST_COMPONENT_LOADING
        });
    
        AxiosHelper.delete('/inspections/checklist-manager/',{
            params:payload
        }).then(
            (res)=>{
                dispatch({
                    type:DELETE_CHECKLIST_COMPONENT_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:DELETE_CHECKLIST_COMPONENT_FAIL,
                    payload:err?.response?.data?.message,
                })
                reject(err)
            }
        )
    })
}


export const updatetInspectionChecklistItem = (payload)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:EDIT_CHECKLIST_COMPONENT_LOADING
        });
    
        AxiosHelper.post(`/inspections/checklist-item-update/`,{payload}).then(
            (res)=>{
                dispatch({
                    type:EDIT_CHECKLIST_COMPONENT_SUCCESS,
                    payload:res.data
                })
    
                resolve(res.data);
            }
    
        ).catch(
            (err)=>{
                dispatch({
                    type:EDIT_CHECKLIST_COMPONENT_FAIL,
                    payload:err.response.data.message,
                })
                reject(err)
            }
        )
    })
}

export const getVehicleRouteList = (params)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:GET_VEHICLE_ROUTES_LOADING
        });
    
        AxiosHelper.get(`/inspections/vehicle-routes`,{
            params:params
        }).then(
            (res)=>{
                dispatch({
                    type:GET_VEHICLE_ROUTES_SUCCESS,
                    payload:res.data
                })
                resolve(res.data);
            }
        ).catch(
            (err)=>{
                dispatch({
                    type:GET_VEHICLE_ROUTES_FAIL,
                    payload:err.response.data.message,
                })
                reject(err)
            }
        )
    })
}

export const getVehicleRouteInspectionReports = (params)=>(dispatch)=>{
    return new Promise((resolve,reject)=>{
        dispatch({
            type:GET_VEHICLE_ROUTE_INSPECTION_LOADING
        });
    
        AxiosHelper.get(`/inspections/vehicle-route-inspections`,{
            params:params
        }).then(
            (res)=>{
                dispatch({
                    type:GET_VEHICLE_ROUTE_INSPECTION_SUCCESS,
                    payload:res.data
                })
                resolve(res.data);
            }
        ).catch(
            (err)=>{
                dispatch({
                    type:GET_VEHICLE_ROUTE_INSPECTION_FAIL,
                    payload:err.response.data.message,
                })
                reject(err)
            }
        )
    })
}